import {StringValidacao} from './string';
import {Construtor} from './construtor';

export class CriterioAvaliacao implements Construtor<CriterioAvaliacao> {

  public idCriterioAvaliacao: number;
  public nomeCriterioAvaliacao: string;
  public pesoCriterioAvaliacao: number;

  constructor(object?: any) {

    if (object !== undefined) {

      if (object instanceof CriterioAvaliacao) {
        this.copyObject(object);
      } else {
        this.parseFromJson(object);
      }

      return this.modeloCompleto() ? this : null;
    }

    return this;
  }

  get obterIdCriterioAvaliacao(): number {
    return this.idCriterioAvaliacao;
  }

  set IdCriterioAvaliacao(idCriterioAvaliacao: any) {
    this.idCriterioAvaliacao = idCriterioAvaliacao;
  }

  get obterNomeCriterioAvaliacao(): string {
    return this.nomeCriterioAvaliacao.slice(0);
  }

  set NomeCriterioAvaliacao(nomeCriterioAvaliacao: any) {
    this.nomeCriterioAvaliacao = StringValidacao.copiarStringValida(nomeCriterioAvaliacao);
  }

  get obterPesoCriterioAvaliacao(): number {
    return this.pesoCriterioAvaliacao;
  }

  set PesoriterioAvaliacao(pesoCriterioAvaliacao: any) {
    this.pesoCriterioAvaliacao = pesoCriterioAvaliacao;
  }

  copyObject(criterio: CriterioAvaliacao): void {

    this.idCriterioAvaliacao = criterio.obterIdCriterioAvaliacao;
    this.nomeCriterioAvaliacao = criterio.obterNomeCriterioAvaliacao;
    this.pesoCriterioAvaliacao = criterio.obterPesoCriterioAvaliacao;
  }

  parseFromJson(criterio: any): void {

    this.IdCriterioAvaliacao = criterio.idCriticidadeRotina;
    this.NomeCriterioAvaliacao = criterio.descricaoCriticidade;
    this.PesoriterioAvaliacao = criterio.pesoCriterioAvaliacao;
  }

  modeloCompleto(): boolean {
    return this.nomeCriterioAvaliacao !== undefined && this.pesoCriterioAvaliacao !== undefined;
  }

  getNewInstance(object?: any): CriterioAvaliacao {
    return new CriterioAvaliacao(object);
  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/criterio-avaliacao.ts